import {
  CREATE_UNITS_FAILURE,
  CREATE_UNITS_REQUEST,
  CREATE_UNITS_SUCCESS,
  GET_UNITS_WITH_CONTACTS_FAILURE,
  GET_UNITS_WITH_CONTACTS_REQUEST,
  GET_UNITS_WITH_CONTACTS_SUCCESS,
  GET_UNIT_ACTIVITY_OVERVIEW_FAILURE,
  GET_UNIT_ACTIVITY_OVERVIEW_REQUEST,
  GET_UNIT_ACTIVITY_OVERVIEW_SUCCESS,
  GET_UNIT_FAILURE,
  GET_UNIT_REQUEST,
  GET_UNIT_SUCCESS,
  SET_MODAL_TYPE,
  UNITS_ORDERING_SUBMITTED,
  UNIT_REMOVE_REQUESTED,
  UNIT_REMOVE_SUCCEEDED,
  UNIT_RESIDENTS_REQUESTED,
  UPDATE_UNIT_FAILURE,
  UPDATE_UNIT_REQUEST,
  UPDATE_UNIT_SUCCESS,
} from '../../actionConstants';
import { getBuildingUnits } from '../Building/actionCreators';

import apiClient from '../../apiClient';
import { CONFIRM } from '../Modal/modalTypes';

export const getUnitResidents = (dispatch, unitId) =>
  dispatch({
    type: UNIT_RESIDENTS_REQUESTED,
    unitId,
    payload: apiClient.unit.getResidents(unitId),
  });

export const getUnitsWithContacts = (dispatch, buildingId) =>
  dispatch({
    type: GET_UNITS_WITH_CONTACTS_REQUEST,
    payload: apiClient.unit.getUnitsWithContacts(buildingId).then(
      (res) => {
        dispatch({
          type: GET_UNITS_WITH_CONTACTS_SUCCESS,
          res,
          buildingId,
        });
        return res?.data;
      },
      (err) =>
        dispatch({
          type: GET_UNITS_WITH_CONTACTS_FAILURE,
          err,
        }),
    ),
  });

export const createUnits = (dispatch, buildingId, data, callback) =>
  dispatch({
    type: CREATE_UNITS_REQUEST,
    isForm: true,
    payload: apiClient.unit.create(buildingId, data).then(
      (res) => {
        dispatch({
          type: CREATE_UNITS_SUCCESS,
        });
        callback && callback();
        return res?.data?.units;
      },
      (err) => {
        dispatch({
          type: CREATE_UNITS_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const updateUnit = (dispatch, buildingId, unitId, data, callback) =>
  dispatch({
    type: UPDATE_UNIT_REQUEST,
    payload: apiClient.unit.update(buildingId, unitId, data).then(
      () => {
        dispatch({
          type: UPDATE_UNIT_SUCCESS,
        });
        callback && callback();
        return true;
      },
      (err) => {
        dispatch({
          type: UPDATE_UNIT_FAILURE,
          err,
        });
        return false;
      },
    ),
  });

export const getUnit = (dispatch, buildingId, unitId) =>
  dispatch({
    type: GET_UNIT_REQUEST,
    payload: apiClient.unit.getUnitById(buildingId, unitId).then(
      (res) => {
        dispatch({
          type: GET_UNIT_SUCCESS,
          res,
        });

        return res;
      },
      (err) => {
        dispatch({
          type: GET_UNIT_FAILURE,
          err,
        });
        return false;
      },
    ),
  });

export const getUnitActivityOverview = (dispatch, buildingId, unitId) =>
  dispatch({
    type: GET_UNIT_ACTIVITY_OVERVIEW_REQUEST,
    payload: apiClient.unit.activityOverview(unitId).then(
      (res) =>
        dispatch({
          type: GET_UNIT_ACTIVITY_OVERVIEW_SUCCESS,
          res,
          buildingId,
          unitId,
        }),
      (err) =>
        dispatch({
          type: GET_UNIT_ACTIVITY_OVERVIEW_FAILURE,
          err,
        }),
    ),
  });

const onDeleteUnit = (dispatch, buildingId, unitId) =>
  dispatch({
    type: UNIT_REMOVE_REQUESTED,
    payload: apiClient.unit.delete(buildingId, unitId).then(() =>
      dispatch({
        type: UNIT_REMOVE_SUCCEEDED,
        unitId,
        buildingId,
        successMessage: 'Unit successfully removed',
      }),
    ),
  });

export const onUnitsReorder = (dispatch, buildingId, data) => {
  const postData = { order: data.map((unit) => unit.id) };
  return dispatch({
    type: UNITS_ORDERING_SUBMITTED,
    redirectId: buildingId,
    successMessage: 'Units order changed',
    payload: apiClient.unit.setOrder(buildingId, postData),
    callback: (res) => {
      if (res) {
        getBuildingUnits(dispatch, {}, buildingId);
      }
    },
  });
};

export const onUnitDelete = (dispatch, buildingId, unit) => {
  const modalProps = {
    bodyText: `Are you sure you want to delete unit "${unit.name}"?`,
    onConfirm: () => onDeleteUnit(dispatch, buildingId, unit.id),
  };
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const placeholder = 'placeholder';
